import { mergeReduce } from './merge';

import type { Parser } from '../../types';

export default function compose(...parsers: Array<Parser>): Parser {
  const type = 'parser';

  parsers = parsers.filter(
    parser => typeof parser === 'object' && parser.type === 'parser',
  );

  if (parsers.length === 0) {
    return Object.freeze({
      name: 'ComposedParser',
      parse: () => ({}),
      type,
    });
  }

  const parse = (data = {}) =>
    parsers.map(({ parse }) => parse(data)).reduceRight(mergeReduce);

  const name = parsers.reduceRight(
    (comp, { name }) => (comp.length ? `${name} << ${comp}` : name),
    '',
  );

  return Object.freeze({
    name,
    parse,
    type,
  });
}
